import { ServerCrash } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

// 500 — Error del servidor.
export const ServerErrorPage = () => {
  const handleReload = (): void => {
    window.location.reload();
  };

  return (
    <div className="bg-bg flex min-h-screen items-center justify-center p-6">
      <Card className="w-full max-w-md text-center">
        <CardHeader className="items-center gap-2">
          <div
            className="bg-surface-2 flex h-16 w-16 items-center justify-center rounded-full"
            aria-hidden="true"
          >
            <ServerCrash className="text-danger h-8 w-8" />
          </div>
          <CardTitle className="text-2xl">500 — Error del servidor</CardTitle>
          <CardDescription>
            Hubo un error en el servidor. Estamos trabajando para resolverlo. Por favor intenta
            recargar la página en unos minutos.
          </CardDescription>
        </CardHeader>
        <CardContent className="flex justify-center">
          <Button type="button" onClick={handleReload}>
            Recargar
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};
